import { useAuthorization, PermissionsApp } from "@/.shared/services/auth/authorization";

/**
 * Claims OCA (p. ej. GESTION_OCAS_SELF en API).
 * En usuario PDS el menú exige además ModulosPds GESTION_OCA o GESTION_OCA_BASICA
 * (ver puedeVerNavOcas / tieneAccesoMenuOcaPds).
 */
export function tieneAccesoOcasSelf(autho: ReturnType<typeof useAuthorization>): boolean {
    return autho.hasPermission(PermissionsApp.GestionAvanzadaOcasAll)
        || autho.hasPermission(PermissionsApp.GestionOcasSelf)
        || autho.hasPermission(PermissionsApp.GestionAvanzadaOcasSelf)
        || autho.hasPermission(PermissionsApp.GestionBasicaOcasSelf)
        || autho.hasPermission(PermissionsApp.GestionOcasBtSelf);
}

export function tienePermisoGestionOcasCatalogo(autho: ReturnType<typeof useAuthorization>): boolean {
    return autho.hasPermission(PermissionsApp.GestionAvanzadaOcasAll);
}

/**
 * Programar visita por claim (ALL / ADVANCED_SELF).
 * Acciones en detalle: backend expone PuedeGestionarVisita solo si el PDS es id_pds_oca tipo OCA
 * (GESTION_OCA_BASICA / id_pds no gestiona visitas).
 */
export function tienePermisoProgramarVisitaOca(autho: ReturnType<typeof useAuthorization>): boolean {
    return autho.hasPermission(PermissionsApp.GestionAvanzadaOcasAll)
        || autho.hasPermission(PermissionsApp.GestionAvanzadaOcasSelf);
}

export function puedeConsultarUbicaciones(autho: ReturnType<typeof useAuthorization>): boolean {
    return tienePermisoGestionOcasCatalogo(autho) || autho.hasPermission(PermissionsApp.ReadAllUbicaciones);
}

export function puedeConsultarCentrosTransformacion(autho: ReturnType<typeof useAuthorization>): boolean {
    return tienePermisoGestionOcasCatalogo(autho) || autho.hasPermission(PermissionsApp.ReadAllCentrosTransformacion);
}

export function puedeConsultarAllOcas(autho: ReturnType<typeof useAuthorization>): boolean {
    return tienePermisoGestionOcasCatalogo(autho) || autho.hasPermission(PermissionsApp.ReadAllOcas);
}

export function puedeConsultarOcas(autho: ReturnType<typeof useAuthorization>): boolean {
    return tieneAccesoOcasSelf(autho) || autho.hasPermission(PermissionsApp.ReadAllOcas);
}
